import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Geo from 'drip/geo';
import Drip from 'drip';
import { getLionConfig } from '@/common/lionConfig';
import Event from 'drip/event';
import WishCard from './CityCard.vue';
export default {
  props: {
    wishCityList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    celebrityId: {
      type: Number,
      default: 0
    },
    isShowCity: {
      type: Boolean,
      default: false
    },
    gCi: {
      type: Number | undefined,
      default: undefined
    }
  },
  components: {
    WishCard: WishCard
  },
  data: function data() {
    return {
      cities: [],
      hasWishedIds: [],
      animation: [],
      isDpH5: ['dianping_chwl', 'dianping_m', 'dianping'].includes(Drip.constant.uaInfo.appName),
      locCity: {} //当前定位
    };
  },

  computed: {},
  watch: {
    wishCityList: {
      handler: function handler(val) {
        if (val && val.length) {
          this.cities = val.map(function (el) {
            return Object.assign({}, el);
          });
          this.hasWishedIds = val.filter(function (el) {
            return el.hasWished;
          }).map(function (el) {
            return el.cityId;
          });
        }
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    this.getLocation();
    window.seedAction({
      bid: "b_movie_h4pju0xl_mv",
      evt: "view"
    });
  },
  methods: {
    getMtCityId: function getMtCityId(_ref) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var cityName, cityId, mtCities, city;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              cityName = _ref.cityName, cityId = _ref.cityId;
              _context.next = 3;
              return getLionConfig('cities');
            case 3:
              mtCities = _context.sent;
              city = {
                nm: '北京',
                id: 1,
                py: 'beijing'
              };
              if (_this.isDpH5) {
                city = mtCities.find(function (el) {
                  return el.nm === cityName;
                });
              } else if (cityId) {
                city = mtCities.find(function (el) {
                  return Number(el.id) === Number(cityId);
                });
              }
              _this.locCity = Object.assign({}, city);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getLocation: function getLocation() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _Drip$constant, cityId, _cityId;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              try {
                if (isNaN(_this2.gCi)) {
                  Geo.getLocCity().then(function (city) {
                    var cityName = city.cityName,
                      cityId = city.cityId,
                      pinyin = city.pinyin;
                    _this2.locCity = {
                      nm: cityName,
                      id: cityId,
                      py: pinyin
                    };
                    // 许愿统一统计美团城市，点评需要将cityid转换成美团的
                    _this2.getMtCityId({
                      cityName: cityName,
                      cityId: cityId
                    });
                  }, function (fail) {
                    // 兜底城市变更为当前选择的城市
                    var cityId = Drip.constant.cityId;
                    _this2.getMtCityId({
                      cityId: cityId
                    });
                  }).catch(function (err) {
                    console.warn(err);
                  });
                } else {
                  cityId = Number(_this2.gCi) === 0 ? Drip === null || Drip === void 0 ? void 0 : (_Drip$constant = Drip.constant) === null || _Drip$constant === void 0 ? void 0 : _Drip$constant.cityId : _this2.gCi;
                  _this2.getMtCityId({
                    cityId: cityId
                  });
                }
                Event.on('locCityChange', function (city) {
                  var cityName = city.cityName,
                    cityId = city.cityId,
                    pinyin = city.pinyin;
                  _this2.locCity = {
                    nm: cityName,
                    id: cityId,
                    py: pinyin
                  };
                  if (_this2.isDpH5) {
                    _this2.getMtCityId({
                      cityName: cityName
                    });
                  }
                });
              } catch (error) {
                _this2.$owlReportError('艺人主页-许愿卡片定位失败', error);
                _cityId = Drip.constant.cityId;
                _this2.getMtCityId({
                  cityId: _cityId
                });
              }
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    isWished: function isWished(id) {
      return this.hasWishedIds.includes(id);
    },
    toAddCity: function toAddCity() {
      this.bidParams('b_movie_luc8gux2_mc', '', this.cities.length);
      // type:1加场，2想看
      this.$emit('onAddCity', {
        type: 2
      });
    },
    onWishChange: function onWishChange(data, item, index) {
      this.bidParams('b_movie_lct1cotg_mc', item.cityId, index);
      this.$emit('onWishChange', data);
    },
    bidParams: function bidParams(bid, cityId, index) {
      var params = {
        evt: 'click',
        bid: bid,
        custom: {
          custom: {
            celebrity_id: this.celebrityId,
            city_id: cityId,
            position: index
          }
        }
      };
      window.seedAction(params);
    }
  }
};